import React from "react";
import { BattleState } from "../../State/State";
import { BattleStages } from "./types";
import { CardContainer } from "./CardContainer";

interface BattleCardsProps {
  battleState: BattleState | null;
  battleStage: BattleStages;
  onMainCardClick: () => void;
  isDefeatAnimating?: boolean;
  showBattleAnimation?: boolean;
}

export const BattleCards: React.FC<BattleCardsProps> = ({
  battleState,
  battleStage,
  onMainCardClick,
  isDefeatAnimating = false,
  showBattleAnimation = false,
}) => {
  return (
    <>
      <div
        className={`card-container absolute left-[37%] top-[5%] w-[26%] h-[20%] top-main ${
          showBattleAnimation ? "battle-animation" : ""
        }`}
      >
        <div className="w-full h-full border-4 border-black/20 antique"></div>
        <CardContainer hexagenUid={battleState?.defending?.main} />
      </div>
      <div
        className={`card-container absolute left-[7%] top-[15%] w-[24%] h-[18%] top-left ${
          showBattleAnimation ? "battle-animation" : ""
        }`}
      >
        <div className="w-full h-full border-4 border-black/20 antique">
          <CardContainer hexagenUid={battleState?.defending?.secondary} />
        </div>
      </div>
      <div
        className={`card-container absolute right-[7%] top-[15%] w-[24%] h-[18%] top-right ${
          showBattleAnimation ? "battle-animation" : ""
        }`}
      >
        <div className="w-full h-full border-4 border-black/20 antique">
          <CardContainer hexagenUid={battleState?.defending?.third} />
        </div>
      </div>
      <div
        className={`card-container absolute left-[37%] bottom-[5%] w-[26%] h-[20%] bottom-main ${
          isDefeatAnimating ? "card-defeat-animation" : ""
        } ${showBattleAnimation ? "battle-animation" : ""}`}
      >
        <div
          className="w-full h-full border-4 border-black/20 antique"
          onClick={onMainCardClick}
        >
          <CardContainer
            hexagenUid={battleState?.attacking?.main}
            highlighted={
              battleStage === BattleStages.CHOOSE_MAIN_ATTACKING_CARD
            }
          />
        </div>
      </div>
      <div
        className={`card-container absolute left-[7%] bottom-[15%] w-[24%] h-[18%] bottom-left ${
          showBattleAnimation ? "battle-animation" : ""
        }`}
      >
        <div className="w-full h-full border-4 border-black/20 antique">
          <CardContainer
            hexagenUid={battleState?.attacking?.secondary}
            highlighted={
              battleStage === BattleStages.SELECT_SECONDARY_SIDE_CARD
            }
          />
        </div>
      </div>
      <div
        className={`card-container absolute right-[7%] bottom-[15%] w-[24%] h-[18%] bottom-right ${
          showBattleAnimation ? "battle-animation" : ""
        }`}
      >
        <div className="w-full h-full border-4 border-black/20 antique">
          <CardContainer
            hexagenUid={battleState?.attacking?.third}
            highlighted={battleStage === BattleStages.SELECT_THIRD_SIDE_CARD}
          />
        </div>
      </div>
    </>
  );
};
